// extracted by mini-css-extract-plugin
module.exports = {"Loader":"styles_Loader__2hizZ","LoaderDocumentation":"styles_LoaderDocumentation__1dD0y"};